// extracted by mini-css-extract-plugin
module.exports = {"item":"Style_item__t09XE","title":"Style_title__1I5AH","detail":"Style_detail__3YYv4"};